import {Injectable} from '@angular/core';
import {ActivatedRoute, Params, Router} from "@angular/router";
import {FilterControl} from "../interface/filter-control";
import {FilteredValueFromKeyService} from "./filtered-value-from-key.service";
import {NormalFilterControl} from "../interface/normal-filter-control";
import {RangeFilterControl} from "../interface/range-filter-control";
import {SegmentCategoryControl} from "../interface/segment-category-control";

@Injectable({
	providedIn: 'root'
})
export class FilterUrlModifierService {

	constructor(
		private _router: Router,
		private _activatedRoute: ActivatedRoute,
		private _filteredValueFromKey: FilteredValueFromKeyService
	) {
	}


	public modify(controls: FilterControl) {

		// console.log(controls);
		let queryParams: Params = {};

		if (this._activatedRoute.snapshot.queryParams['search']) {
			queryParams['search'] = this._activatedRoute.snapshot.queryParams['search'];
		}

		for (const [key, value] of Object.entries(controls)) {

			if (key === 'normalFilterControls') {

				value.forEach((control: NormalFilterControl) => {

					const filterKey: string = control.name;
					const filterValues: string[] =
						this._filteredValueFromKey.getValuesFromNormalFilterControls(control.options);

					if (filterValues.length > 0) {
						queryParams[filterKey] = encodeURIComponent(filterValues.join());
					}

				});
			}


			if (key === 'colorFilterControls') {

				const filterKey: string = value[0].name;
				const filterValues: string[] =
					this._filteredValueFromKey.getValuesFromColorFilterControls(value[0].options);

				if (filterValues.length > 0) {
					queryParams[filterKey] = encodeURIComponent(filterValues.join());
				}
			}


			if (key === 'rangeFilterControls') {

				value.forEach((control: RangeFilterControl) => {

					if (control.name === 'GSM') {
						const filterKey: string = control.name;
						const filterValues: string[] =
							this._filteredValueFromKey.getValuesFromRangeFilterControls(control.values);

						// console.log(filterValues)
						if (filterValues.length > 0) {
							queryParams[filterKey] = encodeURIComponent(filterValues.join());
						}
					}

					if (control.name === 'Availability') {
						const filterKey: string = control.name;
						const filterValues: string[] =
							this._filteredValueFromKey.getValuesFromRangeFilterControls(control.values);

						// console.log(filterValues)
						if (filterValues.length > 0) {
							queryParams[filterKey] = encodeURIComponent(filterValues.join());
						}
					}

					if (control.name === 'Price') {
						const filterKey: string = control.name;
						const filterValues: string[] =
							this._filteredValueFromKey.getValuesFromRangeFilterControls(control.values);

						// console.log(filterValues)
						if (filterValues.length > 0) {
							queryParams[filterKey] = encodeURIComponent(filterValues.join());
						}
					}


				});
			}


			if (key === 'nestedControls') {

				value.forEach((control: SegmentCategoryControl): void => {
					const filterKey: string = 'segment-' + control.name;
					const filterValues: string[] =
						this._filteredValueFromKey.getValuesFromNestedFilterControls(control.options);

					if (filterValues.length > 0) {
						queryParams[filterKey] = encodeURIComponent(filterValues.join());
					}
				})
			}

			if (key === 'singleFilterControls') {

				const filterKey: string = value[0].name;
				const filterValues: string[] =
					this._filteredValueFromKey.getValuesFromSingleFilterControls(value[0].options);

				if (filterValues.length > 0) {
					queryParams[filterKey] = encodeURIComponent(filterValues.join());
				}
			}

		}

			this._router.navigate(
				[],
				{
					relativeTo: this._activatedRoute,
					queryParams: queryParams,
					queryParamsHandling: null
				}
			).then(r => {
				if (!r) {
					// console.error('error routing to query param!');
				}
			});





	}

}
